module.exports = __webpack_public_path__ + "static/media/YF57_1.fb195833.jpg";